export { default } from './BlogHeroImage'
